import { Injectable } from '@angular/core';
import { StsHttpService } from './sts-http.service';
import { Observable } from 'rxjs';


Injectable()
export class StsRecaptchaService {

    constructor(private http: StsHttpService) {}

    public getRecaptchaSiteKey(): Observable<any> {
        return this.http.get<any>('/api/recaptcha/sitekey');
    }
}
